var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0011 9.7005L22.3029 16.8105L22.4597 17.2949H22.9688H30.4245L24.3905 21.695L23.9808 21.9937L24.137 22.4761L26.4404 29.5914L20.4136 25.1965L20.0011 24.8958L19.5887 25.1965L13.5618 29.5914L15.8652 22.4761L16.0214 21.9937L15.6117 21.695L9.5777 17.2949H17.0334H17.5426L17.6994 16.8105L20.0011 9.7005Z",
    stroke: "#58F2F0",
    strokeWidth: 1.4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#4C5A99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.847c4db491a1d6e23b292247be6d7e34.svg";
export { ForwardRef as ReactComponent };